import React from 'react'
type Props= {
    size?: number,
    color?: string,
    strokeWidth?: number,
    onClick?: React.MouseEventHandler<SVGSVGElement>,
    style?: React.CSSProperties,
    classname?: string
}
function EditBlueIcon({size=16, color="#17B2EB", strokeWidth=1.4, onClick, style, classname}: Props) {
  return (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick} style={style} className={classname}>
<path d="M3.5 21H21.5" stroke="#17B2EB" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.5 13.36V17H9.1586L19.5 6.65405L15.8476 3L5.5 13.36Z" stroke="#17B2EB" stroke-width="1.2" stroke-linejoin="round"/>
</svg>
  )
}

export default EditBlueIcon